import { getBasicConfigs, getAdvancedConfigs } from "../setting"

import * as customSettings from '../customization/setting'

export const getSettingTranslations = () => {

  let ns = ["common", "sidebar"]

  if (customSettings?.getCustomTranslations) {
    ns = [...ns, ...customSettings.getCustomTranslations()]
  }

  return { ns }
}

export const getSettingConfigs = ({ t }) => {

  return {
    basicConfigs: getBasicConfigs({ t }),
    advancedConfigs: getAdvancedConfigs({ t }),
    customConfigs: (customSettings?.getCustomConfigs) ? customSettings.getCustomConfigs({ t }) : []
  }

}